/* LMM Warenkorb-Slide-out — net-new, ohne Änderungen an Header/PDP.
   - fängt die LMM-Produktformulare ab -> AJAX /cart/add.js -> Drawer öffnen:
     PDP (#lmm-product-form) sowie die Produktkarten in Collection und Suche (form.cartline)
   - fängt Klicks auf Warenkorb-Links (/cart) ab -> Drawer öffnen (statt Seitenwechsel)
   - Menge über Eingabefeld, +/- und Entfernen via /cart/change.js
   - Re-Render der Drawer-Inhalte über die Section Rendering API (?sections=lmm-cart-drawer),
     mit Fallback auf /cart-Vollseite. Preise brutto; Netto = Brutto/1,19 kommt aus dem Liquid.
   Delegierte Listener (document) -> keine Bindings gehen beim Re-Render verloren.

   LMM (2026-07-28) — Mengenbedienung neu. Gemessener Ausgangsstand:
     - ein Plus-Klick brauchte 592 ms, bis sich die Zahl überhaupt bewegte
       (/cart/change.js 418 ms, danach ein vollständiges Section-Rendering 144 ms),
     - fünf schnelle Klicks (60 ms Abstand) ergaben +1 statt +5, weil jeder Klick während
       .is-busy verworfen wurde — also kein reines Tempoproblem, sondern eine falsche Menge,
     - fünf wirklich ausgeführte Erhöhungen dauerten 3.047 ms (10 Requests).
   Neu:
     1. Der sichtbare Wert ändert sich SOFORT (optimistisch).
     2. Je Position gibt es genau einen Zielwert; schnelle Änderungen werden 300 ms
        zusammengefasst und nur der zuletzt gewünschte Wert geht an Shopify.
     3. Je Position ist höchstens EIN /cart/change.js gleichzeitig unterwegs; entsteht
        währenddessen ein neuerer Zielwert, wird direkt danach nur dieser gesendet.
     4. Kein Klick geht mehr verloren — die Sperre liegt nicht mehr auf der Zeile.
     5. Gerendert wird erst, wenn für ALLE Positionen nichts mehr aussteht.
   Die 300 ms sind nicht geraten: die gemessene Serverantwort liegt bei 343–435 ms, das
   Fenster bleibt also deutlich darunter und dominiert die Gesamtdauer nicht. Denselben
   Wert benutzt Horizons eigene Warenkorbseite (assets/component-cart-items.js), damit
   sich Drawer und Warenkorbseite gleich anfühlen. Kein Polling, kein Intervall.
   Shopify bleibt die maßgebliche Quelle: nach jeder Antwort wird der servergerenderte
   Stand übernommen, bei HTTP 422 die Shopify-Meldung angezeigt und der bestätigte Wert
   wiederhergestellt. Das Theme erfindet KEINE eigene Mengenobergrenze. */
(function () {
  if (window.__lmmCartDrawerInit) return;
  window.__lmmCartDrawerInit = true;

  var vpeSyncLaeuft = false;
  var refreshLaeuft = 0;
  var vpeSyncFehler = false;
  var refreshFehler = false;
  var letzterVpeSyncZiel = null;
  var cartMutationSeq = 0;
  var confirmedRefreshSeq = 0;
  var horizonFetchAktiv = 0;
  var horizonDebounceTimer = null;
  var nachlaufRefreshTimer = null;
  var _origFetch = window.fetch;

  (function injectCheckoutLockStyle() {
    try {
      if (document.head && !document.getElementById('lmm-checkout-lock-style')) {
        var st = document.createElement('style');
        st.id = 'lmm-checkout-lock-style';
        st.textContent =
          'html.lmm-checkout-locked .additional-checkout-buttons, html.lmm-checkout-locked shopify-accelerated-checkout, html.lmm-checkout-locked shopify-accelerated-checkout-cart { position: relative !important; pointer-events: auto !important; cursor: wait !important; opacity: 0.55 !important; } ' +
          'html.lmm-checkout-locked .additional-checkout-buttons::after, html.lmm-checkout-locked shopify-accelerated-checkout::after, html.lmm-checkout-locked shopify-accelerated-checkout-cart::after { content: "" !important; position: absolute !important; inset: 0 !important; z-index: 2147483647 !important; cursor: wait !important; background: transparent !important; } ' +
          'html.lmm-checkout-locked .additional-checkout-buttons > *, html.lmm-checkout-locked .additional-checkout-buttons iframe, html.lmm-checkout-locked shopify-accelerated-checkout > *, html.lmm-checkout-locked shopify-accelerated-checkout-cart > * { pointer-events: none !important; visibility: hidden !important; }';
        document.head.appendChild(st);
      }
    } catch (e) {}
  })();

  function leseVpeState() {
    grab();
    if (!panel) return null;
    return panel.querySelector('[data-lmm-vpe-state]');
  }

  function istVpeStateGueltig(el) {
    if (!el || !el.getAttribute) return false;
    var needed = el.getAttribute('data-lmm-vpe-sync-needed');
    return needed === 'true' || needed === 'false';
  }

  function hatUnberechtigtenVpeCode(el) {
    if (!el || !el.getAttribute) return true;
    var haveRaw = el.getAttribute('data-lmm-vpe-have') || '';
    var wantRaw = el.getAttribute('data-lmm-vpe-only') || '';
    var haveArr = haveRaw ? haveRaw.split(',').filter(Boolean) : [];
    if (!haveArr.length) return false;
    var wantArr = wantRaw ? wantRaw.split(',').filter(Boolean) : [];
    for (var i = 0; i < haveArr.length; i++) {
      if (wantArr.indexOf(haveArr[i]) === -1) return true;
    }
    return false;
  }

  function istVpeSyncBlockierend(el) {
    if (!istVpeStateGueltig(el)) return true;
    if (el.getAttribute('data-lmm-vpe-sync-needed') !== 'true') return false;
    if (hatUnberechtigtenVpeCode(el)) return true;
    var want = el.getAttribute('data-lmm-vpe-want') || '';
    return letzterVpeSyncZiel !== want;
  }

  function aktualisiereCheckoutSperre() {
    try {
      if (document.documentElement && document.documentElement.classList) {
        var st = leseVpeState();
        var unbestaetigt = istVpeSyncBlockierend(st);
        var gesperrt = nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0 || refreshFehler || vpeSyncFehler || unbestaetigt || (cartMutationSeq !== confirmedRefreshSeq);
        document.documentElement.classList.toggle('lmm-checkout-locked', !!gesperrt);
      }
    } catch (e) {}
  }

  function markiereCartMutation() {
    cartMutationSeq++;
    letzterVpeSyncZiel = null;
    aktualisiereCheckoutSperre();
    return cartMutationSeq;
  }

  function starteHorizonDebounceSperre() {
    markiereCartMutation();
    if (horizonDebounceTimer) window.clearTimeout(horizonDebounceTimer);
    horizonDebounceTimer = window.setTimeout(function () {
      horizonDebounceTimer = null;
      aktualisiereCheckoutSperre();
      if (horizonFetchAktiv === 0 && refreshLaeuft === 0 && !vpeSyncLaeuft && !nochInArbeit() && cartMutationSeq !== confirmedRefreshSeq) {
        refresh(true, true, false);
      }
    }, 380);
    aktualisiereCheckoutSperre();
  }

  function pruefeIstNoteOnlyUpdate(urlStr, init) {
    if (!/\/cart\/update(\.js)?($|[?#])/.test(urlStr)) return false;
    if (!init || typeof init.body !== 'string') return false;
    try {
      var parsed = JSON.parse(init.body);
      if (parsed && typeof parsed === 'object') {
        var keys = Object.keys(parsed);
        return keys.length === 1 && keys[0] === 'note';
      }
    } catch (e) {}
    return false;
  }

  if (typeof _origFetch === 'function' && !_origFetch.__lmmWrapped) {
    var wrappedFetch = function (input, init) {
      var urlStr = typeof input === 'string' ? input : (input && input.url) || '';
      var isInternalVpe = init && init.__lmmInternal === true;
      var isNoteOnly = !isInternalVpe && pruefeIstNoteOnlyUpdate(urlStr, init);
      var isCartMut = !isInternalVpe && !isNoteOnly && /\/cart\/(add|change|update|clear)(\.js)?($|[?#])/.test(urlStr);
      if (isCartMut) {
        if (horizonDebounceTimer) {
          window.clearTimeout(horizonDebounceTimer);
          horizonDebounceTimer = null;
        }
        horizonFetchAktiv++;
        markiereCartMutation();
      }
      var p;
      try {
        p = _origFetch.apply(this, arguments);
      } catch (err) {
        if (isCartMut) {
          horizonFetchAktiv = Math.max(0, horizonFetchAktiv - 1);
          aktualisiereCheckoutSperre();
        }
        throw err;
      }
      if (isCartMut && p && typeof p.then === 'function') {
        var dec = function () {
          horizonFetchAktiv = Math.max(0, horizonFetchAktiv - 1);
          aktualisiereCheckoutSperre();
          if (horizonFetchAktiv === 0 && cartMutationSeq !== confirmedRefreshSeq && refreshLaeuft === 0 && !vpeSyncLaeuft && !nochInArbeit()) {
            if (nachlaufRefreshTimer) window.clearTimeout(nachlaufRefreshTimer);
            nachlaufRefreshTimer = window.setTimeout(function () {
              nachlaufRefreshTimer = null;
              if (cartMutationSeq !== confirmedRefreshSeq && refreshLaeuft === 0 && !vpeSyncLaeuft && !nochInArbeit()) {
                refresh(true, true, false);
              }
            }, 120);
          }
        };
        p.then(dec, dec);
      }
      return p;
    };
    wrappedFetch.__lmmWrapped = true;
    window.fetch = wrappedFetch;
  }

  function istSyncAktiv() {
    return nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0 || (cartMutationSeq !== confirmedRefreshSeq);
  }

  function fuehreVpeSyncAus(wantCodes, expectedSeq, leise) {
    if (vpeSyncLaeuft || nochInArbeit()) return Promise.resolve(false);
    if (expectedSeq !== undefined && expectedSeq !== cartMutationSeq) return Promise.resolve(false);
    letzterVpeSyncZiel = wantCodes;
    vpeSyncLaeuft = true;
    vpeSyncFehler = false;
    aktualisiereCheckoutSperre();
    return fetch(root_url() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: wantCodes }),
      credentials: 'same-origin',
      __lmmInternal: true
    })
      .then(function (r) {
        vpeSyncLaeuft = false;
        if (!r || !r.ok) {
          vpeSyncFehler = true;
          refreshFehler = true;
          letzterVpeSyncZiel = null;
          aktualisiereCheckoutSperre();
          return false;
        }
        if (expectedSeq !== undefined && expectedSeq !== cartMutationSeq) {
          letzterVpeSyncZiel = null;
          return refresh(true, true, false);
        }
        return refresh(leise !== undefined ? leise : true, true, true);
      })
      .catch(function () {
        vpeSyncLaeuft = false;
        vpeSyncFehler = true;
        refreshFehler = true;
        letzterVpeSyncZiel = null;
        aktualisiereCheckoutSperre();
        return false;
      });
  }

  function pruefeVpeRabattSync() {
    if (vpeSyncLaeuft || nochInArbeit()) return Promise.resolve(false);
    var st = leseVpeState();
    if (!istVpeStateGueltig(st)) {
      refreshFehler = true;
      aktualisiereCheckoutSperre();
      return Promise.resolve(false);
    }
    var needed = st.getAttribute('data-lmm-vpe-sync-needed');
    var want = st.getAttribute('data-lmm-vpe-want') || '';
    if (needed !== 'true') {
      letzterVpeSyncZiel = null;
      vpeSyncFehler = false;
      aktualisiereCheckoutSperre();
      return Promise.resolve(false);
    }
    if (letzterVpeSyncZiel === want && !vpeSyncFehler) return Promise.resolve(false);
    return fuehreVpeSyncAus(want, cartMutationSeq, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { pruefeVpeRabattSync(); });
  } else {
    window.setTimeout(function () { pruefeVpeRabattSync(); }, 20);
  }


  var root = null;
  var panel = null;
  var lastFocus = null;

  /* Zusammenfassungsfenster für schnelle Mengenänderungen (ms). */
  var DEBOUNCE_MS = 300;
  /* key -> zuletzt gewünschte Menge, solange noch nicht gesendet/bestätigt */
  var zielwert = {};
  /* key -> laufender setTimeout */
  var timer = {};
  /* key -> true, solange ein /cart/change.js für diese Position unterwegs ist */
  var laeuft = {};
  /* gemerkte Fehlermeldung, bis alle Positionen fertig sind */
  var offenerFehler = null;
  /* key -> zuletzt von Shopify ABGELEHNTE Menge. Verhindert, dass derselbe aussichtslose
     Wert erneut gesendet wird. Ohne diese Sperre kann aus einer abgelehnten Eingabe eine
     Request-Kette werden, die Shopify irgendwann mit HTTP 429 drosselt (live gemessen). */
  var abgelehnt = {};
  /* true, solange der Panel-Inhalt gerade ausgetauscht wird. Chrome feuert beim Ersetzen
     von innerHTML ein blur auf das noch verbundene Eingabefeld — ohne diese Sperre würde
     die Übernahme-Logik den gerade verworfenen Entwurf sofort wieder abschicken. */
  var rendert = false;

  var clarityCart = (function () {
    var state = window.__lmmClarityState = { version: 1, consent: false, tags: {}, events: [], attribute: 'idle', excluded_skus: 0 };
    var previous = null, ref = '', persisted = '', attempted = '', pendingAdd = false, pendingOpen = false;
    var sent = {}, emptySeen = false;
    var refPattern = /^lmm_[a-f0-9]{16}$/;
    function allowed() {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        state.consent = typeof window.clarity === 'function' && !!privacy &&
          typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
      } catch (e) { state.consent = false; }
      return state.consent;
    }
    function validRef(value) { return refPattern.test(value || '') && !/\d{13}/.test(value); }
    function storage(key, value) {
      try {
        if (value === undefined) return window.sessionStorage.getItem(key);
        window.sessionStorage.setItem(key, value);
      } catch (e) {}
      return '';
    }
    function snapshot() {
      var el = document.querySelector('[data-lmm-clarity-cart]');
      if (!el) return null;
      var quantities = {}, excluded = 0;
      Array.prototype.forEach.call(el.querySelectorAll('[data-lmm-clarity-sku]'), function (line) {
        var sku = line.getAttribute('data-lmm-clarity-sku') || '';
        var qty = Number(line.getAttribute('data-quantity'));
        if (/^(1000|1030)\d{6}$/.test(sku) && Number.isSafeInteger(qty) && qty > 0) {
          quantities[sku] = (quantities[sku] || 0) + qty;
        } else excluded++;
      });
      var count = Number(el.getAttribute('data-item-count'));
      var cents = Number(el.getAttribute('data-total-cents'));
      var country = el.getAttribute('data-country') || '';
      var mode = el.getAttribute('data-shipping-mode') || '';
      if (!Number.isSafeInteger(count) || count < 0 || !Number.isSafeInteger(cents) || cents < 0 || !/^[A-Z]{2}$/.test(country)) return null;
      if (['de', 'at', 'ch_below', 'ch_above', 'other'].indexOf(mode) === -1) mode = 'other';
      return { el: el, quantities: quantities, count: count, cents: cents, country: country, mode: mode,
        currency: el.getAttribute('data-currency'), ref: el.getAttribute('data-cart-ref') || '', excluded: excluded };
    }
    function call(method, key, value) {
      if (!allowed()) return false;
      try {
        if (method === 'set') window.clarity('set', key, value);
        else window.clarity('event', key);
        return true;
      } catch (e) { state.delivery = 'call_failed'; return false; }
    }
    function tag(key, value) {
      var serial = JSON.stringify(value);
      if (sent[key] !== serial && call('set', key, value)) sent[key] = serial;
      state.tags[key] = value;
    }
    function event(step) {
      tag('cart_last_step', step);
      if (call('event', 'lmm_' + step)) {
        state.events.push({ name: 'lmm_' + step, cart_ref: ref, cart_skus: state.tags.cart_skus,
          cart_sku_qty: state.tags.cart_sku_qty, cart_value_band: state.tags.cart_value_band,
          cart_item_count: state.tags.cart_item_count, cart_country: state.tags.cart_country });
        if (state.events.length > 40) state.events.shift();
      }
    }
    function newRef() {
      if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') return '';
      var bytes = new Uint8Array(8);
      window.crypto.getRandomValues(bytes);
      var value = 'lmm_' + Array.prototype.map.call(bytes, function (v) { return v.toString(16).padStart(2, '0'); }).join('');
      return validRef(value) ? value : '';
    }
    function persist(s) {
      if (!allowed() || !s.count || !validRef(ref) || persisted === ref || attempted === ref) return;
      var savingRef = ref;
      attempted = savingRef;
      state.attribute = 'saving';
      try {
        fetch(root_url() + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin', keepalive: true, __lmmInternal: true,
          body: JSON.stringify({ attributes: { _lmm_clarity_ref: savingRef } })
        }).then(function (r) { if (!r.ok) throw new Error('attribute_http'); return r.json(); })
          .then(function (cart) {
            if (!cart.attributes || cart.attributes._lmm_clarity_ref !== savingRef) throw new Error('attribute_readback');
            if (ref !== savingRef) return;
            persisted = savingRef;
            state.attribute = 'saved';
            var current = document.querySelector('[data-lmm-clarity-cart]');
            if (current) current.setAttribute('data-cart-ref', savingRef);
          }).catch(function () { if (ref === savingRef) state.attribute = 'failed'; });
      } catch (e) { state.attribute = 'failed'; }
    }
    function sync() {
      try {
        var s = snapshot();
        if (!s) return;
        if (!allowed()) { if (!s.count) emptySeen = true; previous = s; pendingAdd = pendingOpen = false; sent = {}; return; }
        if (istSyncAktiv() || refreshFehler || vpeSyncFehler) return;
        state.excluded_skus = s.excluded;
        if (s.count > 0) {
          if (!ref) {
            var fresh = emptySeen || storage('lmm_clarity_empty') === '1';
            ref = !fresh && validRef(s.ref) ? s.ref : newRef();
            if (!validRef(ref)) { state.attribute = 'random_unavailable'; return; }
          }
          if (s.ref === ref) { persisted = ref; state.attribute = 'saved'; }
          storage('lmm_clarity_ref', ref);
          storage('lmm_clarity_empty', '0');
          emptySeen = false;
          persist(s);
        } else {
          emptySeen = true;
          storage('lmm_clarity_empty', '1');
          storage('lmm_clarity_ref', '');
        }
        var skus = Object.keys(s.quantities).sort();
        if (validRef(ref)) tag('cart_ref', ref);
        tag('cart_skus', skus.length ? skus : ['empty']);
        tag('cart_sku_qty', skus.length ? skus.map(function (sku) { return sku + ':' + s.quantities[sku]; }) : ['empty']);
        tag('cart_item_count', String(s.count));
        var band = s.cents === 0 ? '0' : s.cents < 1500 ? '0_15' : s.cents < 3000 ? '15_30' : s.cents < 5000 ? '30_50' : s.cents < 10000 ? '50_100' : '100_plus';
        tag('cart_value_band', s.currency === 'EUR' ? band : 'unknown_currency');
        tag('cart_country', s.country);
        tag('cart_shipping_mode', s.mode);
        if (!state.tags.cart_last_step) tag('cart_last_step', isCartPath(location.pathname.replace(/\/+$/, '')) ? 'cart_page_view' : 'cart_loaded');
        if (pendingAdd) event('add_to_cart');
        else if (previous && JSON.stringify(previous.quantities) !== JSON.stringify(s.quantities)) {
          var removed = Object.keys(previous.quantities).some(function (sku) { return !s.quantities[sku]; });
          var added = skus.some(function (sku) { return !previous.quantities[sku]; });
          event(removed ? 'cart_item_remove' : added ? 'add_to_cart' : 'cart_qty_change');
        }
        if (pendingOpen) event('cart_drawer_open');
        previous = s;
        pendingAdd = pendingOpen = false;
        if (!s.count) { ref = ''; persisted = ''; attempted = ''; }
      } catch (e) { state.delivery = 'bridge_error'; }
    }
    function interaction(step) {
      if (!allowed()) return;
      sync();
      if (state.tags.cart_country) event(step);
    }
    document.addEventListener('visitorConsentCollected', function () {
      if (!allowed()) { pendingAdd = pendingOpen = false; sent = {}; return; }
      pendingOpen = !!document.querySelector('[data-lmm-cd].is-open');
      sync();
    });
    document.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'SCRIPT' && /^https:\/\/([a-z0-9-]+\.)?clarity\.ms\//.test(e.target.src || '')) sync();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('button[name="checkout"], input[name="checkout"], .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button')) {
        interaction('checkout_click'); return;
      }
      var a = t.closest('a[href]');
      if (!a) return;
      var path = pathOf(a);
      if (/(^|\/)checkout($|\/)/.test(path)) interaction('checkout_click');
      else if (/\/pages\/zahlung-und-versand$/.test(path)) interaction('shipping_info_click');
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout' && (!state.events.length || state.events[state.events.length - 1].name !== 'lmm_checkout_click')) interaction('checkout_click');
    }, true);
    window.addEventListener('pageshow', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else window.setTimeout(sync, 0);
    return {
      sync: sync,
      added: function () { if (allowed()) pendingAdd = true; },
      opened: function () { if (allowed()) { pendingOpen = true; sync(); } }
    };
  })();


  function root_url() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }
  function pathOf(a) { try { return new URL(a.href, location.origin).pathname.replace(/\/+$/, ''); } catch (e) { return ''; } }
  function isCartPath(p) { return /(^|\/)cart$/.test(p); }

  function grab() {
    if (!root || !document.body.contains(root)) {
      root = document.querySelector('[data-lmm-cd]');
      panel = root ? root.querySelector('.lmm-cd__panel') : null;
    } else {
      panel = root.querySelector('.lmm-cd__panel');
    }
    return root;
  }

  function focusables() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function isOpen() { return !!(root && root.classList.contains('is-open')); }
  function setBusy(b) { if (root) root.classList.toggle('is-busy', !!b); }

  function open() {
    if (!grab()) return;
    if (!isOpen()) lastFocus = document.activeElement;
    var bd = root.querySelector('.lmm-cd__backdrop'); if (bd) bd.hidden = false;
    var clarityWasOpen = isOpen();
    root.classList.add('is-open');
    if (!clarityWasOpen) clarityCart.opened();
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () { if (panel) { try { panel.focus(); } catch (e) {} } }, 40);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function showError(msg) {
    grab();
    if (!panel) return;
    var body = panel.querySelector('.lmm-cd__body');
    if (!body) return;
    var ex = body.querySelector('.lmm-cd__err'); if (ex) ex.parentNode.removeChild(ex);
    var el = document.createElement('div');
    el.className = 'lmm-cd__err';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    body.insertBefore(el, body.firstChild);
  }

  function updateHeaderCount(count) {
    var links = document.querySelectorAll('a.lmmh-svc__link, a[href$="/cart"]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.lmm-cd-root')) return;
      if (!isCartPath(pathOf(a))) return;
      var badge = a.querySelector('.lmmh-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lmmh-cart-count';
          a.appendChild(badge);
        }
        badge.textContent = count;
        badge.setAttribute('aria-label', count + ' Artikel im Warenkorb');
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    });
  }

  /* LMM (2026-07-29): Der Header-Zähler hängt jetzt zusätzlich am zentralen
     Warenkorb-Ereignis von Horizon.

     Bis hierher rief ausschließlich der Drawer updateHeaderCount() auf — nach seinem
     eigenen Re-Render. Mengenänderungen auf der REGULÄREN Warenkorbseite liefen daran
     vorbei; gemessen am 2026-07-29 live: Mengenfeld 11, /cart.js item_count 11, Badge blieb
     10 und korrigierte sich erst beim nächsten Seitenaufbau.

     Ein eigener Kanal ist dafür nicht nötig: Horizon hat mit 'cart:update'
     (ThemeEvents.cartUpdate, assets/events.js) bereits einen. assets/component-cart-items.js
     sendet ihn nach jeder bestätigten Änderung mit dem vollständigen Warenkorbobjekt und
     nach einer Ablehnung mit dem frisch gelesenen Serverstand. Genau daran hängt der Zähler
     jetzt: ein einziger Listener, keine zweite Warenkorbarchitektur, kein zusätzlicher
     Request, kein Reload, keine DOM-Summe aus einzelnen Feldern.

     Maßgeblich ist immer eine belegte GESAMTZAHL (cart.item_count), nie eine Teilmenge:
     Horizons Produktformular benutzt für CartAddEvent denselben Ereignisnamen, trägt in
     data.itemCount aber die HINZUGEFÜGTE Menge. Dieser Fall wird übersprungen — dort
     aktualisiert der Drawer den Zähler ohnehin selbst, nachdem er den Warenkorb neu
     gelesen hat. Ohne belegte Gesamtzahl bleibt der Zähler unangetastet. */
  document.addEventListener('quantity-selector:update', function (e) {
    var t = e && e.target;
    if (t && t.closest && t.closest('cart-items-component')) {
      starteHorizonDebounceSperre();
    }
  }, true);

  document.addEventListener('input', function (e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (t.getAttribute && (t.getAttribute('data-lmm-cd-qtyinput') !== null || t.getAttribute('data-lmm-note') !== null)) return;
    if (t.closest('cart-items-component') && (t.matches('input[name="updates[]"], input[type="number"], quantity-selector-component input'))) {
      starteHorizonDebounceSperre();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (t.getAttribute && (t.getAttribute('data-lmm-cd-qtyinput') !== null || t.getAttribute('data-lmm-note') !== null)) return;
    if (t.closest('cart-items-component') && (t.matches('input[name="updates[]"], input[type="number"], quantity-selector-component input'))) {
      starteHorizonDebounceSperre();
    }
  }, true);

  document.addEventListener('discount:update', function () {
    markiereCartMutation();
    refresh(true, true);
  });

  document.addEventListener('cart:update', function (e) {
    var detail = (e && e.detail) || {};
    var data = detail.data || {};
    if (detail.sourceId === 'lmm-cart-drawer' || data.source === 'lmm-cart-drawer') return;
    if (data.source === 'product-form-component') {
      clarityCart.added();
      markiereCartMutation();
      refresh(true, true);
      return;
    }

    var res = detail.resource;
    var anzahl = null;
    if (res && typeof res.item_count === 'number') anzahl = res.item_count;
    else if (data.source === 'cart-items-component' && typeof data.itemCount === 'number') anzahl = data.itemCount;

    if (anzahl === null) return;
    updateHeaderCount(anzahl);
    if (data.source === 'cart-items-component') {
      markiereCartMutation();
      refresh(true, true);
    }
  });

  /* --- Mengenfeld: Hilfsfunktionen -------------------------------------------------- */

  /* Feld einer Position finden. Bewusst eine Schleife statt eines Attributselektors:
     der Warenkorbschlüssel enthält einen Doppelpunkt und Hexzeichen, und der Selektor
     müsste sonst je nach Browser maskiert werden. */
  function mengenfeld(key) {
    grab();
    if (!panel || !key) return null;
    var list = panel.querySelectorAll('[data-lmm-cd-qtyinput]');
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-key') === key) return list[i];
    }
    var vid = String(key).split(':')[0];
    var matches = [];
    for (i = 0; i < list.length; i++) {
      var dk = list[i].getAttribute('data-key') || '';
      if (dk.split(':')[0] === vid) matches.push(list[i]);
    }
    return matches.length === 1 ? matches[0] : null;
  }

  function zeileVon(key) {
    grab();
    if (!panel || !key) return null;
    var list = panel.querySelectorAll('.lmm-cd__line');
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-key') === key) return list[i];
    }
    var vid = String(key).split(':')[0];
    var matches = [];
    for (i = 0; i < list.length; i++) {
      var dk = list[i].getAttribute('data-key') || '';
      if (dk.split(':')[0] === vid) matches.push(list[i]);
    }
    return matches.length === 1 ? matches[0] : null;
  }

  /* Zuletzt SERVERSEITIG bestätigte Menge — Grundlage für Escape und ungültige Eingaben. */
  function bestaetigt(key) {
    var el = mengenfeld(key);
    if (!el) return null;
    var v = parseInt(el.getAttribute('data-confirmed'), 10);
    return isFinite(v) && v > 0 ? v : 1;
  }

  function minusSyncen(el) {
    var box = el.parentNode;
    if (!box || !box.querySelector) return;
    var minus = box.querySelector('[data-step="-1"]');
    if (!minus) return;
    var v = parseInt(el.value, 10);
    minus.disabled = !(isFinite(v) && v > 1);
  }

  function zeigeMenge(key, q) {
    var el = mengenfeld(key);
    if (!el) return;
    el.value = String(q);
    minusSyncen(el);
  }

  /* Aktuell gewünschte Menge: erst der noch nicht gesendete Zielwert, sonst das Feld,
     sonst der bestätigte Wert. */
  function gewuenscht(key) {
    if (Object.prototype.hasOwnProperty.call(zielwert, key)) return zielwert[key];
    var el = mengenfeld(key);
    var v = el ? parseInt(el.value, 10) : NaN;
    if (!isFinite(v) || v < 1) v = bestaetigt(key) || 1;
    return v;
  }

  function nochInArbeit() {
    if (horizonFetchAktiv > 0 || horizonDebounceTimer !== null) return true;
    var k;
    for (k in zielwert) { if (Object.prototype.hasOwnProperty.call(zielwert, k)) return true; }
    for (k in timer) { if (timer[k]) return true; }
    for (k in laeuft) { if (laeuft[k]) return true; }
    return false;
  }

  function setSyncing(b) { if (root) root.classList.toggle('is-syncing', !!b); }

  /* Live-Region für Screenreader. Liegt außerhalb von .lmm-cd__panel, weil dessen
     innerHTML bei jedem Re-Render ersetzt wird — eine Live-Region darin würde beim
     Austausch verstummen. */
  function melde(text) {
    grab();
    if (!root) return;
    var el = root.querySelector('[data-lmm-cd-status]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'lmm-cd__srstatus';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('data-lmm-cd-status', '');
      root.appendChild(el);
    }
    el.textContent = text;
  }

  function zeigeMengenfehler(key, msg) {
    var li = zeileVon(key);
    if (!li) { showError(msg); melde(msg); return; }
    var alt = li.querySelector('.lmm-cd__qtyerr');
    if (alt) alt.parentNode.removeChild(alt);
    var el = document.createElement('p');
    el.className = 'lmm-cd__qtyerr';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    (li.querySelector('.lmm-cd__info') || li).appendChild(el);
  }

  /* Fokus und Auswahl im Mengenfeld über den Austausch des Panel-HTML retten. */
  function fokusMerken() {
    var el = document.activeElement;
    if (!el || !el.getAttribute || el.getAttribute('data-lmm-cd-qtyinput') === null) return null;
    var s = null, e = null;
    try { s = el.selectionStart; e = el.selectionEnd; } catch (x) {}
    return { key: el.getAttribute('data-key'), wert: el.value, s: s, e: e };
  }

  function fokusZurueck(snap) {
    if (!snap) return;
    var el = mengenfeld(snap.key);
    if (!el) return;
    el.value = snap.wert;
    minusSyncen(el);
    try {
      el.focus();
      if (snap.s !== null) el.setSelectionRange(snap.s, snap.e);
    } catch (x) {}
  }

  /* Noch nicht gesendete Zielwerte nach einem Re-Render wieder anzeigen, damit der
     servergerenderte ältere Wert eine laufende Eingabe nicht überschreibt. */
  function zielwerteWiederAnzeigen() {
    for (var k in zielwert) {
      if (Object.prototype.hasOwnProperty.call(zielwert, k)) zeigeMenge(k, zielwert[k]);
    }
  }

  function applyPanelHTML(sourceEl) {
    var newPanel = sourceEl.querySelector('.lmm-cd__panel');
    grab();
    if (newPanel && panel) {
      var snap = fokusMerken();
      rendert = true;
      try {
        ['data-lmm-vpe-sync-needed', 'data-lmm-vpe-want', 'data-lmm-vpe-only', 'data-lmm-vpe-have', 'data-lmm-max-vpe-slots', 'data-lmm-vpe-ranked'].forEach(function (attr) {
          if (newPanel.hasAttribute(attr)) panel.setAttribute(attr, newPanel.getAttribute(attr));
          else panel.removeAttribute(attr);
        });
        panel.innerHTML = newPanel.innerHTML;
        zielwerteWiederAnzeigen();
        fokusZurueck(snap);
      } finally {
        rendert = false;
      }
      var cnt = panel.querySelector('[data-lmm-cd-count]');
      updateHeaderCount(cnt ? (parseInt(cnt.textContent, 10) || 0) : 0);
      document.dispatchEvent(new CustomEvent('lmm:cart-rendered'));
      pruefeVpeRabattSync();
      return true;
    }
    return false;
  }

  /* LMM (2026-07-29): Die reguläre Warenkorbseite mit synchronisieren.

     Gemessener Ausgangsstand (live auf /cart, Drawer geöffnet, Menge 10 -> 25):
     Shopify /cart.js item_count 25, Drawer 25, Header-Zähler 25 — die Seite darunter blieb
     bei 10 („Warenkorb 10", Mengenfeld 10, alte Summen), bis sie neu aufgebaut wurde. Nach
     dem Schließen des Drawers sah der Kunde also einen veralteten Warenkorb.

     Die Ursache war KEIN fehlender Empfänger und kein fehlendes Rendering: Horizons
     assets/component-cart-items.js hört bereits auf 'cart:update' und rendert die
     Warenkorbsection selbst neu, sobald das Ereignis von außerhalb der Komponente kommt
     (#handleCartUpdate: mit data.sections per morphSection, sonst über sectionRenderer).
     Es fehlte allein der SENDER — der Drawer aktualisierte nur seine eigene Section und
     meldete das über 'lmm:cart-rendered'. Gemessen wurde nach einer Drawer-Änderung genau
     ein Ereignis: 'lmm:cart-rendered'. 'cart:update' kam nie.

     Deshalb kein zweiter Warenkorbweg, sondern zwei kleine Ergänzungen an dieser Stelle:
       1. Der ohnehin stattfindende Section-Aufruf holt die Warenkorbsection GLEICH MIT
          (?sections=lmm-cart-drawer,<cart-section-id>) — derselbe Request, gemessen 153 ms,
          also kein zusätzlicher Section-Request und kein zusätzliches /cart.js.
       2. Danach wird Horizons vorhandenes 'cart:update' mit genau diesem servergerenderten
          HTML gesendet. Die Seite morpht sich selbst; live gegengeprüft: Feld 10 -> 25,
          Titel „Warenkorb 25", Drawer bleibt offen, NULL zusätzliche Requests.

     Nur auf der Warenkorbseite: Ohne <cart-items-component> wird weder eine Section
     angefordert noch ein Ereignis gesendet. Damit ändert sich auf PDP, Collection und
     Suche nichts — dort hören andere Komponenten (sticky-add-to-cart, price-per-item,
     quick-add) ebenfalls auf 'cart:update' und sollen kein neues Ereignis bekommen.
     Der Zähler bleibt unberührt: 'resource' ist bewusst leer und die Quelle heißt
     'lmm-cart-drawer', sodass der Header-Listener oben nichts doppelt setzt — der Drawer
     schreibt den Zähler direkt in applyPanelHTML(). */
  function cartSeitenSections() {
    var out = [];
    var list = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < list.length; i++) {
      /* Die Drawer-Variante der Komponente wäre der eigene Kontext — nicht anfassen. */
      if (list[i].dataset.drawer !== undefined) continue;
      var id = list[i].dataset.sectionId;
      if (id && out.indexOf(id) === -1) out.push(id);
    }
    return out;
  }

  /* Ein Ereignis je abgeschlossener Änderung. Der Empfänger rendert nur; er schreibt
     nichts in den Warenkorb zurück, es kann also keine Ereignisschleife entstehen. */
  function seiteSynchronisieren(sections, ids) {
    if (!ids || !ids.length) return;
    var mit = null;
    if (sections) {
      for (var i = 0; i < ids.length; i++) {
        if (typeof sections[ids[i]] === 'string') {
          if (!mit) mit = {};
          mit[ids[i]] = sections[ids[i]];
        }
      }
    }
    var cnt = panel ? panel.querySelector('[data-lmm-cd-count]') : null;
    var daten = { source: 'lmm-cart-drawer' };
    if (cnt) daten.itemCount = parseInt(cnt.textContent, 10) || 0;
    /* Ohne HTML holt sich die Komponente die Section selbst — genau ein Nachschlag,
       nur für die Warenkorbsection. Das ist der Fallbackweg, nicht der Regelfall. */
    if (mit) daten.sections = mit;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: {}, sourceId: 'lmm-cart-drawer', data: daten }
    }));
  }

  /* leise = true: kein .is-busy. Wird nach Mengenänderungen benutzt, damit die Zeile
     währenddessen bedienbar bleibt (die Vollsperre war die Ursache verlorener Klicks).
     cartGeaendert = true: der Warenkorb wurde serverseitig verändert -> die reguläre
     Warenkorbseite mitziehen. Beim bloßen Öffnen des Drawers bleibt sie unangetastet. */
  function refresh(leise, cartGeaendert, _isVpeSyncRetry) {
    if (!leise) setBusy(true);
    var seqAtStart = cartMutationSeq;
    refreshLaeuft++;
    aktualisiereCheckoutSperre();
    var seiten = cartGeaendert ? cartSeitenSections() : [];
    var url = root_url() + '?sections=lmm-cart-drawer';
    if (seiten.length) url += ',' + seiten.map(encodeURIComponent).join(',');
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', __lmmInternal: true })
      .then(function (r) {
        if (!r || !r.ok) return null;
        return r.json();
      })
      .then(function (data) {
        var html = data && data['lmm-cart-drawer'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var stateEl = tmp.querySelector('[data-lmm-vpe-state]');
          if (!istVpeStateGueltig(stateEl)) {
            throw new Error('Missing or invalid VPE state element in section response');
          }
          var syncNeeded = stateEl.getAttribute('data-lmm-vpe-sync-needed') === 'true';
          var wantCodes = stateEl.getAttribute('data-lmm-vpe-want') || '';
          if (syncNeeded && !_isVpeSyncRetry && !vpeSyncLaeuft && !nochInArbeit() && seqAtStart === cartMutationSeq) {
            return fuehreVpeSyncAus(wantCodes, seqAtStart, leise);
          }
          if (applyPanelHTML(tmp)) {
            seiteSynchronisieren(data, seiten);
            var hasUnentitledVpe = hatUnberechtigtenVpeCode(stateEl);
            if (!syncNeeded && !nochInArbeit() && seqAtStart === cartMutationSeq && !vpeSyncFehler) {
              confirmedRefreshSeq = seqAtStart;
              refreshFehler = false;
            } else if (syncNeeded) {
              if (_isVpeSyncRetry && !hasUnentitledVpe && !nochInArbeit() && seqAtStart === cartMutationSeq && !vpeSyncFehler) {
                confirmedRefreshSeq = seqAtStart;
                refreshFehler = false;
              } else if (_isVpeSyncRetry && hasUnentitledVpe) {
                refreshFehler = true;
              }
            }
            aktualisiereCheckoutSperre();
            return true;
          }
        }
        // Fallback: /cart-Vollseite parsen (Drawer ist via theme.liquid auch dort vorhanden)
        return fetch(root_url() + 'cart', { headers: { Accept: 'text/html' }, credentials: 'same-origin', __lmmInternal: true })
          .then(function (r) {
            if (!r || !r.ok) throw new Error('Cart fallback HTTP error');
            return r.text();
          })
          .then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            var fbState = doc.querySelector('[data-lmm-vpe-state]');
            if (!istVpeStateGueltig(fbState) || !applyPanelHTML(doc)) {
              throw new Error('Cart fallback parse failed');
            }
            seiteSynchronisieren(null, seiten);
            var fbSyncNeeded = fbState.getAttribute('data-lmm-vpe-sync-needed') === 'true';
            var fbHasUnentitled = hatUnberechtigtenVpeCode(fbState);
            if (fbSyncNeeded && !_isVpeSyncRetry) {
              return pruefeVpeRabattSync();
            }
            if (!fbSyncNeeded && !nochInArbeit() && seqAtStart === cartMutationSeq && !vpeSyncFehler) {
              confirmedRefreshSeq = seqAtStart;
              refreshFehler = false;
            } else if (fbSyncNeeded && _isVpeSyncRetry && !fbHasUnentitled && !nochInArbeit() && seqAtStart === cartMutationSeq && !vpeSyncFehler) {
              confirmedRefreshSeq = seqAtStart;
              refreshFehler = false;
            } else if (fbSyncNeeded && _isVpeSyncRetry && fbHasUnentitled) {
              refreshFehler = true;
            }
            aktualisiereCheckoutSperre();
            return true;
          });
      })
      .catch(function () {
        refreshFehler = true;
        aktualisiereCheckoutSperre();
        return false;
      })
      .then(function (ok) {
        refreshLaeuft = Math.max(0, refreshLaeuft - 1);
        if (!leise && refreshLaeuft === 0) setBusy(false);
        aktualisiereCheckoutSperre();
        if (seqAtStart !== cartMutationSeq && refreshLaeuft === 0 && !vpeSyncLaeuft && !nochInArbeit()) {
          return refresh(true, true, false);
        }
        if (ok) clarityCart.sync();
        return ok;
      });
  }

  function addToCart(form) {
    markiereCartMutation();
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!idEl || !idEl.value) { form.submit(); return; }
    var fd = new FormData();
    fd.append('id', idEl.value);
    fd.append('quantity', (qtyEl && qtyEl.value) || '1');
    setBusy(true);
    fetch(root_url() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 422) {
          return r.json().then(function (j) { throw { soft: true, msg: (j && (j.description || j.message)) || 'Dieser Artikel ist derzeit nicht verfügbar.' }; });
        }
        if (!r.ok) throw { soft: false };
        return r.json();
      })
      .then(function () { clarityCart.added(); open(); return refresh(false, true); })
      .catch(function (err) {
        setBusy(false);
        var msg = (err && err.soft && err.msg)
          ? err.msg
          : 'Status wird mit dem Warenkorb abgeglichen – bitte prüfen Sie die Menge im Warenkorb.';
        open();
        refresh(false, true, false).then(function () { showError(msg); });
      });
  }

  /* --- Mengenänderung: Zielwert je Position, ein Request je Position ---------------- */

  /* Neuen Zielwert setzen. sofort = true übergeht das Zusammenfassungsfenster
     (Enter, Blur, Entfernen). quantity 0 bedeutet: Position entfernen. */
  function setzeMenge(key, q, sofort) {
    if (!key) return;
    markiereCartMutation();
    q = Math.floor(q);
    if (!isFinite(q) || q < 0) q = 0;
    /* Ein anderer Wunsch als der zuletzt abgelehnte hebt die Sperre wieder auf. */
    if (abgelehnt[key] !== q) delete abgelehnt[key];
    zielwert[key] = q;
    if (q > 0) zeigeMenge(key, q);
    if (timer[key]) { window.clearTimeout(timer[key]); timer[key] = null; }
    setSyncing(true);
    if (sofort) {
      senden(key);
    } else {
      timer[key] = window.setTimeout(function () { timer[key] = null; senden(key); }, DEBOUNCE_MS);
    }
  }

  function senden(key) {
    if (!Object.prototype.hasOwnProperty.call(zielwert, key)) return;
    /* Höchstens ein Request je Position. Läuft schon einer, wird der neuere Zielwert
       unmittelbar nach dessen Antwort nachgeschoben — der Klick geht nicht verloren. */
    if (laeuft[key]) return;
    var ziel = zielwert[key];
    delete zielwert[key];
    /* Denselben bereits abgelehnten Wert nicht erneut senden — sonst entsteht aus einem
       Fehlschlag eine Request-Kette. Stattdessen den bestätigten Stand herstellen. */
    if (abgelehnt[key] === ziel) {
      var alt = mengenfeld(key);
      var konfAlt = bestaetigt(key);
      if (alt && konfAlt !== null) { alt.value = String(konfAlt); minusSyncen(alt); }
      if (!nochInArbeit()) setSyncing(false);
      return;
    }
    laeuft[key] = true;
    var aktFeld = mengenfeld(key);
    var sendKey = (aktFeld && aktFeld.getAttribute('data-key')) || key;
    var otherDomKeys = {};
    grab();
    if (panel) {
      var domKeyEls = panel.querySelectorAll('[data-lmm-cd-qtyinput][data-key]');
      for (var dki = 0; dki < domKeyEls.length; dki++) {
        var dkVal = domKeyEls[dki].getAttribute('data-key');
        if (dkVal && dkVal !== key && dkVal !== sendKey) {
          otherDomKeys[dkVal] = true;
        }
      }
    }

    fetch(root_url() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: sendKey, quantity: ziel }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(
          function (j) { return { ok: r.ok, daten: j }; },
          function () { return { ok: r.ok, daten: null }; }
        );
      })
      .then(function (res) {
        laeuft[key] = false;
        if (!res.ok) {
          /* Shopify hat die Menge abgelehnt oder gekappt (HTTP 422). Das ist die echte
             Bestandsauskunft für diese Variante — change.js gewährt genau den verfügbaren
             Bestand (3 → 3, 15.790 → 15.790). Sie bleibt maßgeblich, wird ehrlich gemeldet
             und derselbe Wunsch wird nicht erneut gesendet. Das Theme setzt keine eigene
             Grenze und umgeht keine. */
          abgelehnt[key] = ziel;
          verwerfen(key);
          return abschluss(key, { art: 'menge', gewuenscht: ziel });
        }
        delete abgelehnt[key];
        if (res.daten && Array.isArray(res.daten.items)) {
          var exactMatch = false;
          var varPrefix = String(key).split(':')[0];
          var candidateKeys = [];
          for (var ii = 0; ii < res.daten.items.length; ii++) {
            var it = res.daten.items[ii];
            if (it && (it.key === key || it.key === sendKey)) { exactMatch = true; break; }
            if (it && String(it.variant_id) === varPrefix && !otherDomKeys[it.key]) {
              candidateKeys.push(it.key);
            }
          }
          var newKey = candidateKeys.length === 1 ? candidateKeys[0] : null;
          if (!exactMatch && newKey && newKey !== key) {
            grab();
            if (panel) {
              var kEls = panel.querySelectorAll('[data-key]');
              for (var ki = 0; ki < kEls.length; ki++) {
                var curAttr = kEls[ki].getAttribute('data-key');
                if (curAttr === key || curAttr === sendKey) {
                  kEls[ki].setAttribute('data-key', newKey);
                }
              }
            }
            if (Object.prototype.hasOwnProperty.call(zielwert, key)) {
              if (!Object.prototype.hasOwnProperty.call(zielwert, newKey)) {
                zielwert[newKey] = zielwert[key];
              }
              delete zielwert[key];
            }
            if (timer[key]) {
              window.clearTimeout(timer[key]);
              delete timer[key];
              (function (migratedKey) {
                timer[migratedKey] = window.setTimeout(function () {
                  timer[migratedKey] = null;
                  senden(migratedKey);
                }, DEBOUNCE_MS);
              })(newKey);
            }
            key = newKey;
          }
        }
        if (Object.prototype.hasOwnProperty.call(zielwert, key)) {
          /* Während des Requests kam ein neuerer Wunsch. Läuft dafür noch ein
             Zusammenfassungsfenster, sendet dieses; sonst sofort nachziehen. */
          if (!timer[key]) return senden(key);
          return;
        }
        return abschluss(key, null);
      })
      .catch(function () {
        laeuft[key] = false;
        verwerfen(key);
        return abschluss(key, { art: 'netz' });
      });
  }


  function verwerfen(key) {
    delete zielwert[key];
    if (timer[key]) { window.clearTimeout(timer[key]); timer[key] = null; }
  }

  /* Fehlertext aus dem TATSÄCHLICHEN Ergebnis bilden, nicht aus der Shopify-Rohmeldung.
     Shopify antwortet beim Kappen mit „Aufgrund der Verfügbarkeit wurden nur N Artikel zu
     deinem Warenkorb hinzugefügt." — das ist beim Ändern einer bestehenden Position falsch:
     es wurde nichts hinzugefügt, die Position wurde auf N gesetzt. Maßgeblich ist die
     serverseitig bestätigte Menge. */
  function fehlertext(f, jetzt) {
    if (f.art === 'netz') {
      return 'Die Menge konnte nicht geändert werden. Bitte prüfen Sie Ihre Verbindung.' +
        (jetzt === null ? '' : ' Die Menge steht weiterhin auf ' + jetzt + '.');
    }
    if (jetzt === null || jetzt <= 0) {
      return 'Die gewünschte Menge ist für diesen Artikel derzeit nicht verfügbar.';
    }
    if (f.gewuenscht && jetzt < f.gewuenscht) {
      return 'Für diesen Artikel sind derzeit maximal ' + jetzt +
        ' Stück bestellbar. Die Warenkorbmenge wurde entsprechend angepasst.';
    }
    return 'Die Menge konnte nicht geändert werden. Die Warenkorbmenge steht auf ' +
      jetzt + ' Stück.';
  }

  /* Gerendert wird erst, wenn für ALLE Positionen nichts mehr aussteht. Sonst würde
     ein Zwischenstand die gerade laufende Eingabe einer anderen Position überschreiben. */
  function abschluss(key, fehler) {
    if (fehler) offenerFehler = { key: key, art: fehler.art, gewuenscht: fehler.gewuenscht };
    if (nochInArbeit()) return Promise.resolve();

    var f = offenerFehler;
    offenerFehler = null;
    return refresh(true, true).then(function () {
      setSyncing(false);
      if (f) {
        var jetzt = bestaetigt(f.key);
        /* Der abgelehnte Wert darf nicht stehen bleiben — auch dann nicht, wenn das Feld
           beim Re-Render den Fokus hatte und sein Entwurf gerettet wurde. Shopify gewinnt. */
        var feldF = mengenfeld(f.key);
        if (feldF && jetzt !== null) { feldF.value = String(jetzt); minusSyncen(feldF); }
        var text = fehlertext(f, jetzt);
        zeigeMengenfehler(f.key, text);
        melde(text);
        return;
      }
      var el = mengenfeld(key);
      var li = zeileVon(key);
      if (el) {
        var name = li && li.querySelector('.lmm-cd__name') ? li.querySelector('.lmm-cd__name').textContent.trim() : '';
        melde((name ? name + ': ' : '') + 'Menge ' + el.value + '. Summen aktualisiert.');
      } else {
        melde('Position entfernt. Summen aktualisiert.');
      }
    });
  }

  /* Eingabe übernehmen (Enter, Verlassen des Feldes). Leer, 0 oder ungültig stellt den
     zuletzt bestätigten Wert wieder her — 0 bedeutet hier bewusst NICHT „entfernen",
     dafür gibt es den Papierkorb. */
  function uebernehmen(el) {
    /* Nicht während eines Re-Renders: Chrome feuert beim Ersetzen des Panel-Inhalts ein
       blur auf das noch verbundene Feld. Ohne diese Sperre würde ein gerade abgelehnter
       Entwurf sofort erneut gesendet — live als Request-Kette bis HTTP 429 beobachtet. */
    if (rendert) return;
    if (!el || !document.contains(el)) return;
    var key = el.getAttribute('data-key');
    var konf = bestaetigt(key) || 1;
    var v = parseInt(el.value, 10);
    if (!isFinite(v) || v < 1) {
      verwerfen(key);
      el.value = String(konf);
      minusSyncen(el);
      if (!nochInArbeit()) setSyncing(false);
      return;
    }
    if (v === konf && !Object.prototype.hasOwnProperty.call(zielwert, key)) {
      minusSyncen(el);
      return;
    }
    setzeMenge(key, v, true);
  }

  function istCheckoutGesperrt() {
    var st = leseVpeState();
    var needsSync = istVpeSyncBlockierend(st);
    return istSyncAktiv() || refreshFehler || vpeSyncFehler || offenerFehler !== null || needsSync;
  }

  function warteAufSyncUndGeheZuCheckout(zielUrl) {
    setBusy(true);
    aktualisiereCheckoutSperre();
    for (var tk in timer) {
      if (timer[tk]) { window.clearTimeout(timer[tk]); timer[tk] = null; senden(tk); }
    }
    var recoveryStarted = false;
    var waitLoop = function (tries) {
      if ((nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0) && tries > 0) {
        window.setTimeout(function () { waitLoop(tries - 1); }, 80);
        return;
      }
      if (nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0) {
        setBusy(false);
        aktualisiereCheckoutSperre();
        showError('Mengen- oder Rabattabgleich läuft noch. Bitte prüfen Sie den Warenkorb und klicken Sie erneut auf „Zur Kasse".');
        return;
      }
      if ((refreshFehler || vpeSyncFehler || cartMutationSeq !== confirmedRefreshSeq || !istVpeStateGueltig(leseVpeState())) && !recoveryStarted) {
        recoveryStarted = true;
        letzterVpeSyncZiel = null;
        refresh(false, true, false).then(function () { waitLoop(Math.max(15, tries - 1)); });
        return;
      }
      pruefeVpeRabattSync().then(function () {
        var stAfter = leseVpeState();
        var stillNeeded = istVpeSyncBlockierend(stAfter);
        if (nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0 || refreshFehler || vpeSyncFehler || stillNeeded || offenerFehler !== null || cartMutationSeq !== confirmedRefreshSeq || hatUnberechtigtenVpeCode(stAfter)) {
          setBusy(false);
          aktualisiereCheckoutSperre();
          showError('Der VPE-Rabatt wurde gerade aktualisiert oder konnte noch nicht bestätigt werden. Bitte prüfen Sie den Betrag und klicken Sie erneut auf „Zur Kasse".');
          return;
        }
        var seqBeforeNote = confirmedRefreshSeq;
        var noteFlush = typeof window.__lmmCartNoteFlush === 'function' ? window.__lmmCartNoteFlush() : Promise.resolve(true);
        noteFlush.then(function (noteOk) {
          if (noteOk === false) {
            setBusy(false);
            aktualisiereCheckoutSperre();
            return;
          }
          var stFinal = leseVpeState();
          var finalNeeded = istVpeSyncBlockierend(stFinal);
          if (nochInArbeit() || vpeSyncLaeuft || refreshLaeuft > 0 || refreshFehler || vpeSyncFehler || finalNeeded || offenerFehler !== null || cartMutationSeq !== confirmedRefreshSeq || confirmedRefreshSeq !== seqBeforeNote) {
            setBusy(false);
            aktualisiereCheckoutSperre();
            showError('Warenkorb wurde während der Bestellnotiz-Speicherung geändert. Bitte prüfen Sie den Betrag und klicken Sie erneut auf „Zur Kasse".');
            return;
          }
          window.location.href = zielUrl || (root_url() + 'checkout');
        });
      });
    };
    waitLoop(75);
  }

  // Der native PDP-Schnellkauf gehört nicht zum synchronisierten Warenkorb-Checkout.
  function istPdpExpressTarget(target) {
    return !!(target && target.closest && target.closest('#lmm-product-form [data-lmm-dynamic-checkout]'));
  }

  // --- LMM-Produktformulare + Warenkorb-Checkout-Submit abfangen ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) { return; }
    var istPdp = form.getAttribute('id') === 'lmm-product-form';
    if (istPdp && (istPdpExpressTarget(e.submitter) || (!e.submitter && istPdpExpressTarget(document.activeElement)))) return;
    var istKarte = form.classList && form.classList.contains('cartline');
    if (istPdp || istKarte) {
      e.preventDefault();
      addToCart(form);
      return;
    }
    var subBtn = e.submitter;
    var act = form.getAttribute('action') || '';
    var istCheckoutSubmit = (subBtn && subBtn.getAttribute && subBtn.getAttribute('name') === 'checkout') || /(^|\/)checkout($|[/?#])/.test(act);
    if (istCheckoutSubmit && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      warteAufSyncUndGeheZuCheckout(root_url() + 'checkout');
    }
  }, true);

  // Capture-Phase-Wächter für Checkout-Klicks und Tastaturbedienung (inkl. Express-Checkout & /cart +/- Buttons)
  document.addEventListener('click', function (e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (istPdpExpressTarget(t)) return;
    if (t.closest('cart-items-component') && t.closest('quantity-selector-component button, button[name="minus"], button[name="plus"], .cart-items__remove, [on\\:click*="onLineItemRemove"]')) {
      starteHorizonDebounceSperre();
      return;
    }
    var accelWrap = t.closest('.additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (accelWrap && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      warteAufSyncUndGeheZuCheckout(root_url() + 'checkout');
      return;
    }
    var chkBtn = t.closest('button[name="checkout"], input[name="checkout"]');
    if (chkBtn && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      warteAufSyncUndGeheZuCheckout(root_url() + 'checkout');
      return;
    }
    var a = t.closest('a');
    if (a && /(^|\/)checkout($|[/?#])/.test(a.getAttribute('href') || '') && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      warteAufSyncUndGeheZuCheckout(a.href);
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (istPdpExpressTarget(t)) return;
    var chkTarget = t.closest('.additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (chkTarget && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      var href = (chkTarget.tagName === 'A' && chkTarget.href) ? chkTarget.href : (root_url() + 'checkout');
      warteAufSyncUndGeheZuCheckout(href);
    }
  }, true);

  // --- Klicks: schließen / Menge / entfernen / Warenkorb-Links ---
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-lmm-cd-close]')) { e.preventDefault(); close(); return; }

    /* Plus/Minus: KEINE Busy-Sperre mehr. Der sichtbare Wert springt sofort, gesendet
       wird nach dem Zusammenfassungsfenster nur der zuletzt gewünschte Zielwert. */
    var qbtn = e.target.closest && e.target.closest('[data-lmm-cd-qty]');
    if (qbtn) {
      e.preventDefault();
      if (qbtn.disabled) return;
      var qkey = qbtn.getAttribute('data-key');
      var schritt = parseInt(qbtn.getAttribute('data-step'), 10) || 0;
      var neu = gewuenscht(qkey) + schritt;
      /* Unter 1 geht es nicht — entfernt wird über den Papierkorb. */
      if (neu < 1) neu = 1;
      setzeMenge(qkey, neu, false);
      return;
    }

    var rbtn = e.target.closest && e.target.closest('[data-lmm-cd-remove]');
    if (rbtn) {
      e.preventDefault();
      var rkey = rbtn.getAttribute('data-key');
      /* Entfernen läuft durch dieselbe Warteschlange wie die Mengenänderung. Damit kann
         kein /cart/change.js mehr auf einen bereits entfernten Schlüssel treffen. */
      var li = zeileVon(rkey);
      if (li) li.classList.add('is-removing');
      setzeMenge(rkey, 0, true);
      return;
    }

    var accelWrap = e.target.closest && e.target.closest('.additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (accelWrap && istCheckoutGesperrt()) {
      e.preventDefault();
      e.stopPropagation();
      warteAufSyncUndGeheZuCheckout(root_url() + 'checkout');
      return;
    }
    var chkBtn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (chkBtn && istCheckoutGesperrt()) {
      e.preventDefault();
      warteAufSyncUndGeheZuCheckout(root_url() + 'checkout');
      return;
    }
    var a = e.target.closest && e.target.closest('a');
    if (a && /(^|\/)checkout($|[/?#])/.test(a.getAttribute('href') || '') && istCheckoutGesperrt()) {
      e.preventDefault();
      warteAufSyncUndGeheZuCheckout(a.href);
      return;
    }
    if (a && !a.hasAttribute('data-no-drawer') && !a.closest('.lmm-cd-root') && isCartPath(pathOf(a))) {
      e.preventDefault();
      grab();
      open();
      refresh();
    }
  });

  // --- Mengenfeld: Tippen, Einfügen, Enter, Escape, Pfeiltasten, Verlassen ---
  function istMengenfeld(el) {
    return !!(el && el.getAttribute && el.getAttribute('data-lmm-cd-qtyinput') !== null);
  }

  /* Nur Ziffern. Ein vorübergehend leeres Feld bleibt leer — es darf während der
     Eingabe nicht auf 1 zurückspringen; entschieden wird erst beim Übernehmen. */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!istMengenfeld(el)) return;
    var alt = el.value;
    var neu = alt.replace(/[^0-9]/g, '').replace(/^0+(?=[0-9])/, '');
    if (neu !== alt) {
      var pos = el.selectionStart;
      el.value = neu;
      if (pos !== null) {
        var korrigiert = Math.max(0, pos - (alt.length - neu.length));
        try { el.setSelectionRange(korrigiert, korrigiert); } catch (x) {}
      }
    }
    minusSyncen(el);
  }, true);

  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!istMengenfeld(el)) return;
    var key = el.getAttribute('data-key');

    if (e.key === 'Enter') {
      e.preventDefault();
      uebernehmen(el);
      try { el.select(); } catch (x) {}
      return;
    }
    if (e.key === 'Escape') {
      var konf = String(bestaetigt(key) || 1);
      var hatEntwurf = el.value !== konf || !!timer[key] ||
        Object.prototype.hasOwnProperty.call(zielwert, key);
      /* Nichts zu verwerfen? Dann Escape durchlassen, damit der Drawer wie gewohnt
         schließt. Sonst nur die noch nicht gespeicherte Eingabe zurücknehmen. */
      if (!hatEntwurf) return;
      e.preventDefault();
      e.stopPropagation();
      verwerfen(key);
      el.value = konf;
      minusSyncen(el);
      if (!nochInArbeit()) setSyncing(false);
      try { el.select(); } catch (x) {}
      melde('Eingabe verworfen. Menge ' + konf + '.');
      return;
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      var n = gewuenscht(key) + (e.key === 'ArrowUp' ? 1 : -1);
      if (n < 1) n = 1;
      setzeMenge(key, n, false);
      try { el.select(); } catch (x) {}
    }
  }, true);

  /* blur steigt nicht auf -> Capture-Phase. */
  document.addEventListener('blur', function (e) {
    if (!istMengenfeld(e.target)) return;
    uebernehmen(e.target);
  }, true);

  // --- ESC + Fokus-Falle ---
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('pagehide', function () {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });

  if (document.readyState !== 'loading') grab();
  else document.addEventListener('DOMContentLoaded', grab);
})();
